import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import TripsPage from "./pages/TripsPage";
import TripFormPage from "./pages/TripFormPage";
import MasterDataPage from "./pages/MasterDataPage";
import UsersPage from "./pages/UsersPage";
import NotificationsPage from "./pages/NotificationsPage";
import ArmadaPage from "./pages/ArmadaPage";
import GajiPage from "./pages/GajiPage";
import EksekutifPage from "./pages/EksekutifPage";
import AuditPage from "./pages/AuditPage";
import InvoicePage from "./pages/InvoicePage";
import GudangPage from "./pages/GudangPage";
import BackupPage from "./pages/BackupPage";
import AuditTrailPage from "./pages/AuditTrailPage";
import LabaRugiPage from "./pages/LabaRugiPage";
import RekapKendaraanPage from "./pages/RekapKendaraanPage";
import SupirTonasePage from "./pages/SupirTonasePage";

const homeFor = (role) => (role === "owner" ? "/" : role === "supir" ? "/tonase" : "/trips");

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-100 text-zinc-400">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<Protected roles={["owner"]}><DashboardPage /></Protected>} />
          <Route path="/eksekutif" element={<Protected roles={["owner"]}><EksekutifPage /></Protected>} />
          <Route path="/rekap-kendaraan" element={<Protected roles={["owner"]}><RekapKendaraanPage /></Protected>} />
          <Route path="/trips" element={<Protected roles={["owner", "admin_operasional", "kasir"]}><TripsPage /></Protected>} />
          <Route path="/tonase" element={<Protected roles={["supir"]}><SupirTonasePage /></Protected>} />
          <Route path="/trip/baru" element={<Protected roles={["owner", "admin_operasional"]}><TripFormPage /></Protected>} />
          <Route path="/trip/:id/edit" element={<Protected roles={["owner", "admin_operasional"]}><TripFormPage /></Protected>} />
          <Route path="/master-data" element={<Protected roles={["owner"]}><MasterDataPage /></Protected>} />
          <Route path="/users" element={<Protected roles={["owner"]}><UsersPage /></Protected>} />
          <Route path="/notifikasi" element={<Protected roles={["owner"]}><NotificationsPage /></Protected>} />
          <Route path="/armada" element={<Protected roles={["owner"]}><ArmadaPage /></Protected>} />
          <Route path="/gaji" element={<Protected roles={["owner", "kasir"]}><GajiPage /></Protected>} />
          <Route path="/audit" element={<Protected roles={["owner"]}><AuditPage /></Protected>} />
          <Route path="/invoice" element={<Protected roles={["owner", "kasir"]}><InvoicePage /></Protected>} />
          <Route path="/gudang" element={<Protected roles={["owner"]}><GudangPage /></Protected>} />
          <Route path="/backup" element={<Protected roles={["owner"]}><BackupPage /></Protected>} />
          <Route path="/jejak-audit" element={<Protected roles={["owner"]}><AuditTrailPage /></Protected>} />
          <Route path="/laba-rugi" element={<Protected roles={["owner"]}><LabaRugiPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
